import StatisticsHeader from '../StatisticsHeader'
import CommonAbilities from './CommonAbilities'
import CommonAreas from './CommonAreas'
import CommonAreasByHierarchy from './CommonAreasByHierarchy'
import CommonCompanies from './CommonCompanies'
import WorkAbilities from './WorkAbilities'

const StatisticsSuccessAreasPage = () => {
    return (
        <div className="w-full flex flex-col gap-6">
            <StatisticsHeader category="Áreas de éxito" />
            <CommonAreas type="bar" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
                <div className="col-span-1">
                    <CommonAreas type="pie" />
                </div>
                <div className="col-span-1 md:col-span-2">
                    <CommonAbilities />
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
                <div className="col-span-1 md:col-span-2">
                    <WorkAbilities />
                </div>
                <div className="col-span-1">
                    <CommonCompanies type="time" />
                </div>
            </div>
            <CommonCompanies type="count" />
            <CommonAreasByHierarchy />
        </div>
    )
}

export default StatisticsSuccessAreasPage
